import React, { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import { useHitTracking } from '../../context/hit-tracking-context';
import { Toast } from 'primereact/toast';
import LiveTickerBar from '../../components/live-ticker-bar/liveTickerBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDown, faFilePdf, faSearch, faUp, faCircle } from '@fortawesome/pro-solid-svg-icons';
import { Col, Container, Row, Nav, Navbar } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Configuration, SecurityDetailServiceApi, AttachmentApi } from '../../services/actionHub';
import { downloadFile, downloadPdf } from '../../helpers/utils';
import Streaming from '../../services/_realtime/price/Streaming';
import NumberFormatter from '../../formatters/NumberFormatter';
import WatchlistAddModal from '../../components/watchlistComponents/watchlistAddModal';
import Blinker from '../../components/blinker/Blinker';
import { setSecurityBarDetail, setSelectedSecurity } from '../../stores/security';
import { APIControl } from '../../helpers/APIControl';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { useTranslation } from "react-i18next";
import './main.scss'; // Ana stil dosyası
import './navbarFix.scss'; // Navbar hover efektleri için özel SCSS - tema değişkenleriyle uyumlu

// Yeni halka arz olmuş bir hissenin ilk işlem gününde hiç fiyat mesajı gelmeyebilir.
// Bu süre sonunda bilgi barı spinner'dan çıkar, verisi olmayan alanlar '-' gösterilir.
const STREAM_DATA_TIMEOUT_MS = 8000;
const NO_DATA_PLACEHOLDER = '-';

const Main = () => {
    const { t } = useTranslation();
    const { trackInteraction } = useHitTracking();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const numberFormatter = useRef(null);
    const stream = useRef(null);
    const streamingUnSub = useRef(null);
    const toast = useRef(null);
    const securityDetailServiceApi = new SecurityDetailServiceApi(new Configuration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const attachmentApi = new AttachmentApi(new Configuration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const token = useSelector((state) => state.auth?.token);
    const selectedSecurity = useSelector((state) => state.security.selectedSecurity);
    const selectedDefaultSecurity = useSelector((state) => state.security.selectedMainDefaultSecurity);

    const [securityDetail, setSecurityDetail] = useState(null);
    const [secuirtyStreamProps, setSecuirtyStreamProps] = useState(null);
    const [isDataLoading, setIsDataLoading] = useState(true); // Veri yükleme durumunu takip etmek için eklenen bayrak
    const [watchlistAddModalData, setWatchlistAddModalData] = useState(null);
    const [isPDFSpinnerShow, setIsPDFSpinnerShow] = useState(false);
    const dataLoadingTimeout = useRef(null);

    // Detay servisi veri dönmese de header'ı aramadan gelen sembol bilgisiyle doldur
    const symbolCode = securityDetail?.code || selectedSecurity?.code;
    const symbolName = securityDetail?.securityName || selectedSecurity?.name;

    const hasStreamValue = (value) => value !== undefined && value !== null && value !== '';

    const formatStreamValue = (value, digits = 2) =>
        hasStreamValue(value) ? numberFormatter.current?.Double(value, digits) : NO_DATA_PLACEHOLDER;

    useEffect(() => {
        stream.current = new Streaming();
        numberFormatter.current = new NumberFormatter();


    }, []);

    useEffect(() => {

        // StockAnalysis rotasında değilsek (örn. logo ile /watchlist'e gidilince) hiçbir şey yapma
        const isOnStockAnalysisRoute = window.location.pathname.toLowerCase().includes('/stockanalysis/');
        if (!isOnStockAnalysisRoute) return;

        // selectedSecurity henüz yüklenmemişse bekle
        if (!selectedSecurity || !selectedSecurity.code) return;

        let urlSecurityCode = window.location.pathname.split("/")[window.location.pathname.split("/").length - 1];

        // URL'deki son segment bir sekme ismi olabilir (summary, indicators, vb.) - bu durumda güncelleme yok
        const tabNames = ['summary', 'indicators', 'financialstatement', 'ratio', 'compare', 'dividend', 'affiliatespartnerships', 'news', 'report'];
        if (tabNames.includes(urlSecurityCode.toLowerCase())) return;

        if (urlSecurityCode.toLowerCase() !== selectedSecurity.code.toLowerCase()) {

            const url = `https://api.rasyonet.com/service-hisselab-spotlight/collections/Hisselab.Symbols/documents/search?q=${urlSecurityCode}&query_by=code&filter_by=visible:true&&listed:true&&class:Equity`;

            fetch(url, {
                method: "GET",
                headers: {
                    "x-typesense-api-key": "masterKeyk8pX5hD0793d8YQC5aD1aEPd7VleSuGP",
                },
            })
                .then((response) => response.json())
                .then((data) => {


                    if (data.hits != undefined && data.hits.length != 0) {

                        dispatch(setSelectedSecurity(data.hits[0].document));

                    }
                    else {
                        //navigate('/StockAnalysis/dividend/TUPRS');
                        window.location.href = '/StockAnalysis/summary/TUPRS';
                    }
                })
                .catch((error) => {
                    console.error("fetchSearchResults Error:", error);
                    navigate('/StockAnalysis/summary/TUPRS');
                });


        }
        else {
            // Sembol değiştiğinde önceki hissenin detayı ekranda kalmasın
            setSecurityDetail(null);
            setWatchlistAddModalData(null);

            // İlk değerleri ayarlarken veri yükleniyor durumunu true olarak işaretliyoruz
            setIsDataLoading(true);
            setSecuirtyStreamProps({ objectId: selectedSecurity.id, lastPrice: null, dailyChange: null, dailyChangePrice: null, direction: faCircle });
            populateSecurityDEtails();
            subscribeToSecurity();

            // Hiç fiyat mesajı gelmezse alanlar sonsuz spinner'da kalmasın
            if (dataLoadingTimeout.current) {
                clearTimeout(dataLoadingTimeout.current);
            }
            dataLoadingTimeout.current = setTimeout(() => setIsDataLoading(false), STREAM_DATA_TIMEOUT_MS);
        }


        return () => {
            if (streamingUnSub.current) {
                streamingUnSub.current.Dispose();
            }
            if (dataLoadingTimeout.current) {
                clearTimeout(dataLoadingTimeout.current);
                dataLoadingTimeout.current = null;
            }
        }
    }, [selectedSecurity]);

    useEffect(() => {
        if (securityDetail) {
            dispatch(
                setSecurityBarDetail(
                    securityDetail
                )
            )
        }
    }, [securityDetail]);

    const populateSecurityDEtails = () => {
        if (selectedSecurity) {
            securityDetailServiceApi.actionhubSecuritydetailGet(token, selectedSecurity.id, "tr-TR").then((response) => {
                const detail = response?.data?.detail;

                // Yeni halka arz olmuş hisselerde detay servisi henüz veri dönmez.
                // Bu bir hata değil; header selectedSecurity ile dolduruluyor, kullanıcıya mesaj gösterilmiyor.
                if (Array.isArray(detail) && detail.length > 0) {
                    detail[0].Code = detail[0].code;
                    setSecurityDetail(detail[0]);
                    setWatchlistAddModalData(detail[0]);
                }
            }
            ).catch((error) => {
                console.error('populateSecurityDEtails: ', error);
            });
        }
    }

    const downloadPDF = () => {
        setIsPDFSpinnerShow(true);
        let selectedSecUniqueCode = selectedSecurity.objectId;
        let selectedSecName = selectedSecurity.uniqueCode;

        if (!selectedSecUniqueCode) {
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('pleaseSelectAStock'), life: 3000 });
            return;
        }

        attachmentApi.attachmentDownloadPdfGet(token, selectedSecUniqueCode, { responseType: 'blob' }).then((response) => {


            var blob = new Blob([response.data], { type: 'application/pdf' });
            var fileName = selectedSecName + '.pdf';

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();

            setTimeout(() => {
                setIsPDFSpinnerShow(false);
            }, 1000);
        }).catch((error) => {
            setIsPDFSpinnerShow(false);
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('componentErrors.dataLoadFailed'), life: 3000 });
        });

    }



    const subscribeToSecurity = () => {
        if (selectedSecurity) {
            streamingUnSub.current = stream.current.subscribe({ objectIds: [selectedSecurity.id] }, (data) => {
                //console.log(data);
                processStreamingData(data);
            });
        }
    }

    const processStreamingData = (msg) => {
        var cmd = msg['@'];

        if (cmd == undefined) return;

        if (cmd == 'heartbeat')
            return;

        setSecuirtyStreamProps((prev) => {

            let item = prev;
            let newItem = null;
            if (item.objectId === msg["@"]) {

                const newLastPrice = 'lastPrice' in msg ? parseFloat(msg.lastPrice).toFixed(2) : item.lastPrice;
                const newDailyChange = 'dailyChange' in msg ? parseFloat(msg.dailyChange).toFixed(2) : item.dailyChange;
                const newDailyChangePrice = 'dailyChangePrice' in msg ? parseFloat(msg.dailyChangePrice).toFixed(2) : item.dailyChangePrice;
                const isPricePositive = parseFloat(newDailyChangePrice) > 0;
                const isIncreasedDailyChangePrice = parseFloat(newDailyChangePrice) > 0;
                const isDecreasedDailyChangePrice = parseFloat(newDailyChangePrice) < 0;
                const newAsk = 'ask' in msg ? parseFloat(msg.ask).toFixed(2) : item.ask;
                const newBid = 'bid' in msg ? parseFloat(msg.bid).toFixed(2) : item.bid;
                const newDailyHigh = 'dailyHigh' in msg ? parseFloat(msg.dailyHigh).toFixed(2) : item.dailyHigh;
                const newDailyLow = 'dailyLow' in msg ? parseFloat(msg.dailyLow).toFixed(2) : item.dailyLow;
                const newDailyVolume = 'dailyVolume' in msg ? numberFormatter.current.Double(msg.dailyVolume, 0) : item.dailyVolume;
                const newLastTradeTime = 'lastTradeTime' in msg ? msg.lastTradeTime : item.lastTradeTime;
                const newLastUpdateDate = 'lastUpdateDate' in msg ? msg.lastUpdateDate : item.lastUpdateDate;

                newItem = {
                    ...item,
                    ask: newAsk,
                    bid: newBid,
                    dailyHigh: newDailyHigh,
                    dailyLow: newDailyLow,
                    dailyVolume: newDailyVolume,
                    lastTradeTime: newLastTradeTime,
                    lastUpdateDate: newLastUpdateDate,
                    dailyChangePrice: newDailyChangePrice,
                    lastPrice: newLastPrice,
                    dailyChange: newDailyChange,
                    direction: isIncreasedDailyChangePrice ? faUp : (isDecreasedDailyChangePrice ? faDown : faCircle),
                    changeColor: isPricePositive ? 'green' : 'red'
                };
            }
            else
                newItem = item;

            return newItem;
        });

        // İlk veri alındığında yükleme durumunu false olarak işaretle
        if (dataLoadingTimeout.current) {
            clearTimeout(dataLoadingTimeout.current);
            dataLoadingTimeout.current = null;
        }
        setIsDataLoading(false);
    }

    const watchlistAddModalDataEffect = (data) => {
        // console.log("watchlistAddModalDataEffect: ", data);
    }

    const handleUpdateData = (updatedData) => {
        // Update the parent component state or perform other actions with the updated data
        setWatchlistAddModalData(updatedData); // Assuming setData is a state setter function in the parent component
    };

    return (
        <div className='stock-analysis-index'>

            <Toast ref={toast} position='bottom-right' />
            <LiveTickerBar />

            <div className='line-green'></div>

            <div className='symbol-bar'>

                <div className='symbol-bar-code-item '>
                    <Row>
                        <Col lg='12'>
                            {/* <FontAwesomeIcon icon={faSearch} className='search-icon' /> */}

                            {symbolCode ? (
                                <label className='security-name'>
                                    {symbolName ? symbolCode + " - " + symbolName : symbolCode}
                                </label>
                            ) : (
                                <div className='security-name-loading'>
                                    <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon' />
                                </div>
                            )}

                        </Col>
                        <Col lg='12' className='security-desc'>
                            {securityDetail?.peerName}
                        </Col>
                    </Row>
                </div>                <div className='symbol-bar-item '>
                    {/* Spinner veya gerçek veri kontrol edildi */}
                    {secuirtyStreamProps && !isDataLoading ? (
                        hasStreamValue(secuirtyStreamProps?.lastPrice) ? (
                            <>
                                <FontAwesomeIcon
                                    icon={secuirtyStreamProps?.direction}
                                    className={`direction-icon mr-2 ${secuirtyStreamProps?.direction == faUp ? 'up-icon' : secuirtyStreamProps?.direction == faDown ? 'down-icon' : ''}`} />

                                <label className={`security-price `}>
                                    {numberFormatter.current?.Double(secuirtyStreamProps?.lastPrice, 2)}₺
                                </label>
                                <label className={`percent-change ${secuirtyStreamProps?.changeColor}`}>
                                    {numberFormatter.current?.Double(secuirtyStreamProps?.dailyChangePrice, 2)} (%{numberFormatter.current?.Double(secuirtyStreamProps?.dailyChange, 2)})
                                </label>
                            </>
                        ) : (
                            // Fiyat mesajı hiç gelmediyse hata gösterme, alanı boş bırak
                            <label className='security-price'>{NO_DATA_PLACEHOLDER}</label>
                        )
                    ) : (
                        <div className='dynamic-data-loading'>
                            <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon' />
                            <span className="loading-text"></span>
                        </div>
                    )}
                </div>

                <div className='button-item '>
                    <Container>
                        <Row className='buttons-row'>
                            <Col lg='auto' md='auto' sm='auto' xs='auto' className='pdf-button'>
                                <FontAwesomeIcon icon={isPDFSpinnerShow ? faSpinnerThird : faFilePdf} spinPulse={isPDFSpinnerShow} className='pdf-icon' onClick={downloadPDF} />

                            </Col>

                            <Col lg='auto' md='auto' sm='auto' xs='auto' className='watchlist-button'>
                                {/* <FontAwesomeIcon icon={faStar} className='star-icon' /> */}
                                <WatchlistAddModal from={'stockAnalysis'} data={watchlistAddModalData} watchlistAddModalDataEffect={watchlistAddModalDataEffect} onUpdateData={handleUpdateData} />
                            </Col>

                        </Row>
                    </Container>
                </div>

            </div>

            <div className='symbol-update-info-bar'>
                <div className='item'>
                    <label className='text'>
                        {t('stockAnalysis.infoBar.lastUpdate')}<span className="colon-space">: </span>
                        {secuirtyStreamProps && !isDataLoading ? (
                            hasStreamValue(secuirtyStreamProps?.lastUpdateDate) || hasStreamValue(secuirtyStreamProps?.lastTradeTime)
                                ? `${secuirtyStreamProps?.lastUpdateDate ?? ''} ${secuirtyStreamProps?.lastTradeTime ?? ''}`.trim()
                                : NO_DATA_PLACEHOLDER
                        ) : (
                            <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon-small' />
                        )}
                    </label>
                </div>

                <div className='divider item'>

                </div>

                <div className='item'>
                    <label className='text'>
                        {t('stockAnalysis.infoBar.volume')}<span className="colon-space">: </span>
                        {secuirtyStreamProps && !isDataLoading ? (
                            <Blinker value={secuirtyStreamProps?.dailyVolume}>
                                {formatStreamValue(secuirtyStreamProps?.dailyVolume, 0)}
                            </Blinker>
                        ) : (
                            <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon-small' />
                        )}
                    </label>
                </div>

                <div className='divider item'>

                </div>

                <div className='item'>
                    <label className='text'>
                        {t('stockAnalysis.infoBar.dayRange')}<span className="colon-space">: </span>
                        {secuirtyStreamProps && !isDataLoading ? (
                            (hasStreamValue(secuirtyStreamProps?.dailyLow) || hasStreamValue(secuirtyStreamProps?.dailyHigh)) ? (
                                <>
                                    <Blinker value={secuirtyStreamProps?.dailyLow} direction="down">
                                        {formatStreamValue(secuirtyStreamProps?.dailyLow, 2)}
                                    </Blinker>
                                    {" - "}
                                    <Blinker value={secuirtyStreamProps?.dailyHigh} direction="up">
                                        {formatStreamValue(secuirtyStreamProps?.dailyHigh, 2)}
                                    </Blinker>
                                </>
                            ) : NO_DATA_PLACEHOLDER
                        ) : (
                            <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon-small' />
                        )}
                    </label>
                </div>


                <div className='divider item'>

                </div>

                <div className='item'>
                    <label className='text'>
                        {t('stockAnalysis.infoBar.buySell')}<span className="colon-space">: </span>
                        {secuirtyStreamProps && !isDataLoading ? (
                            (hasStreamValue(secuirtyStreamProps?.bid) || hasStreamValue(secuirtyStreamProps?.ask)) ? (
                                <>
                                    <Blinker value={secuirtyStreamProps?.bid}>
                                        {formatStreamValue(secuirtyStreamProps?.bid, 2)}
                                    </Blinker>
                                    {" / "}
                                    <Blinker value={secuirtyStreamProps?.ask}>
                                        {formatStreamValue(secuirtyStreamProps?.ask, 2)}
                                    </Blinker>
                                </>
                            ) : NO_DATA_PLACEHOLDER
                        ) : (
                            <FontAwesomeIcon icon={faSpinnerThird} spin className='spinner-icon-small' />
                        )}
                    </label>
                </div>
            </div>

            {/* 

            <nav className='m-b-30 m-t-30'>
                <Link className='p-r-20' to="summary/TPRAS">Özet</Link>

                <Link className='p-r-20' to="indicators/TPRAS">Göstergeler</Link>

                <Link className='p-r-20' to="financialStatement/TPRAS">Mali Tablo</Link>

                <Link className='p-r-20' to="ratio/TPRAS">Rasyo</Link>

                <Link className='p-r-20' to="compare/TPRAS">Karşılaştır</Link>

                <Link className='p-r-20' to="dividend/TPRAS">Temettü</Link>

                <Link className='p-r-20' to="affiliatesPartnerships/TPRAS">İştirakler ve Ortaklıklar</Link>

                <Link className='p-r-20' to="news/TPRAS">Haberler</Link>

                <Link className='p-r-20' to="report/TPRAS">Rapor</Link>
            </nav> */}


            <Navbar expand="lg" className='stock-analysis-navbar m-t-20'>
                <Container className='p-0'>
                    <Navbar.Collapse id="stock-analysis-navbar-nav">
                        <Nav>
                            <NavLink
                                to={'summary/' + selectedSecurity.code}
                                className={({ isActive }) => (isActive ? 'nav-link active-nav-link-border roboto-medium-16' : 'nav-link roboto-medium-16')}
                                onClick={() => trackInteraction('tab/summary')}
                            >
                                {t('stockAnalysis.navBar.summary')}
                            </NavLink>

                            <NavLink
                                to={'indicators/' + selectedSecurity.code}
                                className={({ isActive }) => (isActive ? 'nav-link active-nav-link-border roboto-medium-16' : 'nav-link roboto-medium-16')}
                                onClick={() => trackInteraction('tab/indicators')}
                            >
                                {t('stockAnalysis.navBar.indicators')}
                            </NavLink>

                            <NavLink
                                to={'financialStatement/' + selectedSecurity.code}
                                className={({ isActive }) => (isActive ? 'nav-link active-nav-link-border roboto-medium-16' : 'nav-link roboto-medium-16')}
                                onClick={() => trackInteraction('tab/financialStatement')}
                            >
                                {t('stockAnalysis.navBar.financialStatement')}
                            </NavLink>

                            <NavLink
                                to={'ratio/' + selectedSecurity.code}
                                className={({ isActive }) => (isActive ? 'nav-link active-nav-link-border roboto-medium-16' : 'nav-link roboto-medium-16')}
                                onClick={() => trackInteraction('tab/ratio')}
                            >
                                {t('stockAnalysis.navBar.ratio')}
                            </NavLink>

                            <NavLink
                                to={'compare/' + selectedSecurity.code}
                                className={({ isActive }) => (isActive ? 'nav-link active-nav-link-border roboto-medium-16' : 'nav-link roboto-medium-16')}
                                onClick={() => trackInteraction('tab/compare')}
                            >
                                {t('stockAnalysis.navBar.compare')}
                            </NavLink>

                            <NavLink
                                to={'dividend/' + selectedSecurity.code}
                                className={({ isActive }) => (isActive ? 'nav-link active-nav-link-border roboto-medium-16' : 'nav-link roboto-medium-16')}
                                onClick={() => trackInteraction('tab/dividend')}
                            >
                                {t('stockAnalysis.navBar.dividend')}
                            </NavLink>

                            <NavLink
                                to={'affiliatesPartnerships/' + selectedSecurity.code}
                                className={({ isActive }) => (isActive ? 'nav-link active-nav-link-border roboto-medium-16' : 'nav-link roboto-medium-16')}
                                onClick={() => trackInteraction('tab/affiliatesPartnerships')}
                            >
                                {t('stockAnalysis.navBar.affiliates')}
                            </NavLink>

                            <NavLink
                                to={'news/' + selectedSecurity.code}
                                className={({ isActive }) => (isActive ? 'nav-link active-nav-link-border roboto-medium-16' : 'nav-link roboto-medium-16')}
                                onClick={() => trackInteraction('tab/news')}
                            >
                                {t('stockAnalysis.navBar.news')}
                            </NavLink>

                            <NavLink
                                to={'report/' + selectedSecurity.code}
                                className={({ isActive }) => (isActive ? 'nav-link active-nav-link-border roboto-medium-16' : 'nav-link roboto-medium-16')}
                                onClick={() => trackInteraction('tab/report')}
                            >
                                {t('stockAnalysis.navBar.reports')}
                            </NavLink>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar >
            <Outlet />
        </div>
    );
}

export default Main;